import {Reducers} from '@app/reducers';
import {ConfigService} from '@config/config.service';
import {ChangeStatusDialogComponent} from '@crm/components/leads/change-status-dialog/change-status-dialog.component';
import {CrmTaskDialogComponent} from '@crm/components/leads/crm-task-dialog/crm-task-dialog.component';
import * as leadsBoardTasksActions from '@crm/ngrx/actions/leads-board.actions';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {TaskChangeStatusRequest} from '@services/associations/model/taskChangeStatusRequest';
import {TaskResponse} from '@services/associations/model/taskResponse';
import {ConfirmationDialogComponent} from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import {SharedService} from '@shared/shared.service';
import {take} from 'rxjs/operators';

export class TaskStatusWorker {

    constructor() {
    }

    public static changeTaskStatus(
        store$: Store<Reducers>,
        sharedService: SharedService,
        config: ConfigService,
        translate: TranslateService,
        data: { task: TaskResponse, status: TaskChangeStatusRequest.StatusEnum, prevStatus: TaskChangeStatusRequest.StatusEnum },
        dialogStatus?: TaskChangeStatusRequest.StatusEnum
    ) {
        if (data.status !== TaskChangeStatusRequest.StatusEnum.Done && data.status !== TaskChangeStatusRequest.StatusEnum.Fail) {
            store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatus({
                taskId: data.task.id!,
                request: {status: data.status},
            }));
        } else {
            switch (true) {
                case data.task.type === 'LEAD':
                    // eslint-disable-next-line no-case-declarations
                    const dialog$ = sharedService.openDialog(
                        ChangeStatusDialogComponent,
                        {...config.addItemDialog, maxWidth: '600px'},
                        {
                            task: data.task,
                            ...dialogStatus && {status: dialogStatus}
                        }
                    );

                    dialog$.afterClosed().pipe(
                        take(1),
                    ).subscribe((dialogData: { result: boolean, data: TaskResponse }) => {
                        if (dialogData.result && dialogData.data) {
                            return;
                        } else {
                            store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatusCanceled({
                                ...data.task,
                                status: data.prevStatus
                            }));
                        }
                    });
                    break;
                case data.task.type === 'CALL':
                case data.task.type === 'CONTRACT':
                case data.task.type === 'TASK':
                case data.task.type === 'UX':
                    store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatus({
                        taskId: data.task.id!,
                        request: {status: 'DONE'},
                    }));
                    break;
                case data.task.type === 'SUPPORT':
                case data.task.type === 'REGISTRATION':
                case data.task.type === 'IMPLEMENTATION':
                case data.task.type === 'OVERVIEW':
                case data.task.type === 'DATA':
                case data.task.type === 'DEMO':
                    if (data.task.closeAllowed) {
                        store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatus({
                            taskId: data.task.id!,
                            request: {status: 'DONE'},
                        }));
                        return;
                    }

                    // eslint-disable-next-line no-case-declarations
                    const confirmation$ = sharedService.openDialog(
                        ConfirmationDialogComponent,
                        {},
                        {
                            title: SharedService.getTranslation(
                                translate,
                                'modules.crm.leads.createTaskQuestion',
                            ),
                            cancelText: 'common.buttons.no',
                            submitText: 'common.buttons.yes',
                        }
                    );

                    confirmation$.afterClosed().pipe(
                        take(1)
                    ).subscribe((result) => {
                        if (result) {
                            // eslint-disable-next-line no-case-declarations
                            const taskDialog$ = sharedService.openDialog(
                                CrmTaskDialogComponent,
                                {...config.rightSideDialog, ...config.canMinimizeDialog},
                                {prevTask: data.task}
                            );

                            taskDialog$.afterClosed().pipe(
                                take(1),
                            ).subscribe((dialogData) => {
                                if (dialogData.result) {
                                    store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatus({
                                        taskId: data.task.id!,
                                        request: {status: 'DONE'},
                                    }));
                                } else {
                                    store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatusCanceled({
                                        ...data.task,
                                        status: data.prevStatus
                                    }));
                                }
                            });
                        } else {
                            store$.dispatch(new leadsBoardTasksActions.ChangeTaskStatus({
                                taskId: data.task.id!,
                                request: {status: 'DONE'},
                            }));
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    }
}
